export const KIM_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const KIM_MAX_NUMBER_OF_FILES = 3;
export const KIM_ALLOWED_FILE_TYPES = ['.pdf'];
